import * as React from 'react';

import { PcodeRenderDataCanvas } from '../../../typings/pcode';
import { PcodeCanvasPreview } from '../../PcodeCanvasPreview/PcodeCanvasPreview';
import { CommonCreativeBaseItem } from '../typings';

export const GraphicPreview = React.forwardRef(
    (
        props: {
            item?: CommonCreativeBaseItem;
            pcodeData?: PcodeRenderDataCanvas;
            cls?: string;
        },
        ref: React.RefObject<PcodeCanvasPreview>
    ) => {
        if (!props.item || !props.pcodeData) {
            return null;
        }

        if (ref && ref.current) {
            ref.current.onExternalDataReceived(props.pcodeData, true);
        }

        return (
            <div className={props.cls}>
                <PcodeCanvasPreview ref={ref} pcodeData={props.pcodeData} currentSize={props.item.data} />
            </div>
        );
    }
);
